import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shipping-policy',
  templateUrl: './shipping-policy.component.html',
  styleUrls: ['./shipping-policy.component.less']
})
export class ShippingPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
